<template>
    <div class="page-content-wrapper">
        <div class="content">
            <div class="container-fluid container-fixed-lg">
                <div class="row">
                    <div class="col-lg-4 m-b-10">
                        <div class="card no-border widget-loader-circle no-padding rounded h-100">
                            <div class="m-2">
                            <AdviceContent/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'
import { mapMutations } from 'vuex'
import AdviceContent from './AdviceContent'

export default {
  props: ['advice_id', 'timeframe_id'],
  components: { AdviceContent },
  // computed: {
  //   ...mapGetters([
  //     'getShiftClass',
  //     'getTimeBlock',
  //   ]),
  // },
  methods: {
    ...mapActions([
      'loadAdviceDetails',
    ]),
    ...mapMutations([
      'SET_TIMEFRAME',
    ]),
  },
  created () {
    this.SET_TIMEFRAME(this.timeframe_id)
    this.loadAdviceDetails({adviceId: this.advice_id, timeframeId: this.timeframe_id})
  },
  data () {
    return {}
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/myschedule/AdvicePage.vue